import React from 'react';
import {DataGrid, IconMenu, FormDialog} from 'components/core';
import {CategoriesCtx} from 'components/dataProviders/itemCategories';



  
const columns = {
    name: { 
        field: 'name',
        headerName: 'Nombre',
        flex: 1
    }
}

function RowMenu({row, dataset})
{
    const ctx = React.useContext(CategoriesCtx);
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    }

    const handleOpen = () => {
        setOpen(true);
    }

    const handleConfirm = (data) => {
        setLoading(true);
        ctx.funcs.update(row.categoryID, data).then(() => {
            setLoading(false);
            setOpen(false);
        });
    }

    let items = [
        {
            label: "Editar",
            onClick: () => handleOpen()
        },
        {
            label: "Eliminar",
            onClick: () => {ctx.funcs.delete(row.categoryID)},
            danger: true
        }
    ];
    return <>
    <IconMenu items={items} />
    <FormDialog
    open={open}
    onClose={handleClose}
    onConfirm={handleConfirm}
    title="Editar etiqueta"
    subtitle="Actualiza el nombre de la etiqueta"
    confirm="Actualizar"
    cancel="Cancelar"
    loading={loading}
    fields={[
        {
        type: "text",
        label: "Nombre",
        id: "name",
        placeholder: "",
        mandatory: true,
        value: row.name
        }
    ]}
    />
    </>
}

export default function CategoriesList()
{
    
    const ctx = React.useContext(CategoriesCtx);
    const [data, setData] = React.useState(ctx.data.array);

    const gridColumns = [columns.name, {
        field: 'menu',
        headerName: ' ',
        width: 300,
        align: 'left',
        renderCell: (params) => {
            return <RowMenu row={params.row} />
        }
    }];

    React.useEffect(function filterData(){
        
        let tmpData = [...ctx.data.array];
        
        // apply filters
        tmpData = tmpData.filter((value) => {
            let result = true;
            //result &= (value.disabled === (dataset === "closed"));
            return result;
        });

        setData(tmpData);
    }, [ctx]);
    
    return <>
        <DataGrid 
        rows={data}
        columns={gridColumns}
        loading={ctx.loading}
        density="comfortable"
        />
    </>
}